module.exports = __webpack_public_path__ + "files/6f8ac1e61d979adb6a41540267c57ae7.png";